const initialState = {
    subcategoryList: {
      data: [],
      loading: false,
      error: null
    }
  }
  
  export default function subcategoryReducer(state = initialState, action) {
    switch (action.type) {
      case 'FETCH_SUBCATEGORY_PENDING':
        return {
          ...state,
          subcategoryList: {
            ...state.subcategoryList,
            loading: true,
            error: null
          }
        }
      case 'FETCH_SUBCATEGORY_FULFILLED':
        return {
          ...state,
          subcategoryList: {
            data: action.payload,
            loading: false,
            error: null
          }
        }
      case 'FETCH_SUBCATEGORY_REJECTED':
        return {
          ...state,
          subcategoryList: {
            ...state.subcategoryList,
            loading: false,
            error: action.payload
          }
        }
      default:
        return state
    }
  }